// Packages
import { AnimatePresence, motion } from "framer-motion"
import * as React from "react"
import styled, { createGlobalStyle } from "styled-components"

// Styles
const PageStyles = createGlobalStyle`
html {
  overflow: ${props => props.isModalOpen && "hidden !important"};
}
`
const ModalWrapper = styled(motion.div)`
  cursor: default;
  left: ${props => 0 - props.leftPosition}px;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  /* background-color: hsla(0, 0%, 0%, 0.8); */
  background: rgba(26, 32, 44, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`

// Props
type Props = {
  children: React.ReactNode
  closeModal: Function
  isModalOpen: boolean
  modalAnimate?: number
  modalExit?: object
  modalInitial?: number
  modalTransition?: object
}

// Main Component
function Modal(props: Props) {
  const modalWrapperRef = React.useRef(null)

  return (
    <>
      <PageStyles isModalOpen={props.isModalOpen} />
      <AnimatePresence>
        {props.isModalOpen && (
          <ModalWrapper
            className="modal-wrapper"
            initial={props.modalInitial || { opacity: 0 }}
            animate={
              props.modalAnimate || {
                opacity: 1,
              }
            }
            exit={
              props.modalExit || {
                opacity: 0,
                // transition: {
                //   duration: 0.4,
                // },
              }
            }
            transition={
              props.modalTransition || { duration: 0.2, ease: "easeInOut" }
            }
            onClick={event => {
              if (event.target.classList.contains("modal-wrapper"))
                props.closeModal()
            }}
            ref={modalWrapperRef}
          >
            {props.children}
          </ModalWrapper>
        )}
      </AnimatePresence>
    </>
  )
}

export default Modal
